export enum ApplicationLang {
  fr = 'fr',
  en = 'en',
  de = 'de',
  it = 'it',
  rm = 'rm'
}

export enum PersonType {
  Individual = 'Individual',
  Organization = 'Organization'
}

export enum PersonGender {
  Mx = 'Mx',
  Ms = 'Ms',
  Mr = 'Mr'
}

export interface TranslationBase {
  lang: ApplicationLang;
}

export interface PointCoords {
  type: 'Point';
  coordinates: [number, number];
}

export enum RecurringUnit {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
  Other = 'Other',
  Sporadic = 'Sporadic',
  OneOff = 'OneOff'
}

export enum WeekDay {
  MO = 'MO',
  TU = 'TU',
  WE = 'WE',
  TH = 'TH',
  FR = 'FR',
  SA = 'SA',
  SU = 'SU'
}

export enum DayTime {
  Morning = 'MO',
  Noon = 'NO',
  Afternoon = 'AN',
  Evening = 'EV',
  Night = 'NI'
}
